import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { singularize, toPascalCase } from '@cli-utils/text.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
export function relationshipDataTypeName(field: SchemaField): string {
  if (isUserRelationshipTarget(field.relationship)) {
    return 'UserData'
  }

  const relationshipSingular = singularize(field.relationship ?? 'relationship')
  return `${toPascalCase(relationshipSingular)}Data`
}
